import { createContext } from '@lit/context';
import { SkillsClient } from '../clients/skills-client';

export const skillsClientContext = createContext<SkillsClient>(Symbol('skills-client'));
